import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

function ProtectedAdminRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is admin
  const isAdmin = user?.roles?.some(role => 
    role === 'ROLE_ADMIN' || role === 'ADMIN'
  ) || user?.role === 'ADMIN' || user?.role === 'ROLE_ADMIN';

  if (!isAdmin) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You do not have permission to access the admin panel.</p>
        <a href="/">Return to Home</a>
      </div>
    );
  }

  return children;
}

export default ProtectedAdminRoute;

